import Contextualable from '../../mixins/contextualable'
import Positionable from '../../mixins/positionable'

export default {
  name: 'pop-up',

  mixins: [Contextualable, Positionable],

  props: {
    light: { type: Boolean },
  },

  computed: {
    classes () {
      return {
        ...this.$contextualClasses,
        'pop-up': true,
        'pop-up--absolute': this.absolute || !this.fixed,
        'pop-up--fixed': this.fixed,
        'pop-up--bottom': this.bottom || !this.top,
        'pop-up--top': this.top,
        'pop-up--left': this.left,
        'pop-up--right': this.right,
        'blue--text--after': true,
      }
    },
  },

  render (h) {
    return h('n-fade-transition', { props: { appear: true } }, [
      h('div', {'class': this.classes}, [this.$slots.default])
    ])
  }
}
